import { useState, useEffect } from 'react';
import axios from 'axios';
import { Sparkles, X } from 'lucide-react';
import { API_URL as API } from '../config/api';

export default function InAppUpdateChecker() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if dismissed in this session
    const isDismissed = sessionStorage.getItem('turfx_update_popup_dismissed');
    if (isDismissed === 'true') return;

    axios.get(`${API}/app-version`, { timeout: 6000 })
      .then(res => {
        if (res.data) {
          // If backend returns a published version, show the notification
          setUpdateAvailable(true);
        }
      })
      .catch(() => {
        // Silently catch network errors
      });
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem('turfx_update_popup_dismissed', 'true');
    setDismissed(true);
    setUpdateAvailable(false);
  };

  if (!updateAvailable || dismissed) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 99999,
        background: '#084734',
        color: '#FFFFFF',
        borderRadius: '16px',
        padding: '12px 18px',
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.25)',
        border: '1.5px solid rgba(206, 241, 123, 0.4)',
        maxWidth: '92vw',
        width: '420px',
        animation: 'slideUpPopup 0.3s ease-out forwards',
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          background: 'rgba(206, 241, 123, 0.18)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Sparkles size={18} color="#CEF17B" />
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: '800', fontSize: '0.9rem', color: '#FFFFFF', marginBottom: '2px' }}>
          New update available
        </div>
        <div style={{ fontSize: '0.78rem', color: '#D1E7DD', fontWeight: '500', lineHeight: 1.3 }}>
          A new version of TurfX is available on Google Play Store & App Store.
        </div>
      </div>

      <button
        onClick={handleDismiss}
        style={{
          background: 'rgba(255, 255, 255, 0.15)',
          border: 'none',
          borderRadius: '50%',
          width: '28px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#FFFFFF',
          padding: 0,
          flexShrink: 0,
          transition: 'background 0.2s ease',
        }}
        title="Close"
      >
        <X size={16} />
      </button>

      <style>{`
        @keyframes slideUpPopup {
          from { opacity: 0; transform: translate(-50%, 20px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
}
